import type { UseFormRegister, FieldErrors } from 'react-hook-form';
import { TextField } from '../../../../modal/fields/TextField';
import type { ContactFormData } from './contactForm.schema';

interface ContactFormProps {
    formId: string;
    errors: FieldErrors<ContactFormData>;
    register: UseFormRegister<ContactFormData>;
    onSubmit: (e?: React.BaseSyntheticEvent) => Promise<void>;
}

export function ContactForm({ formId, register, onSubmit, errors }: ContactFormProps) {
    return (
        <form
            id={formId}
            onSubmit={(e) => {
                void onSubmit(e);
            }}
            className="max-h-[70vh] overflow-y-auto px-6"
        >
            <TextField
                label={gettext('NAME')}
                {...register('name')}
                error={errors.name?.message}
                isRequired
                helperText={gettext('CONTACT_FORM_NAME_FIELD_HELP_TEXT')}
            />
            <TextField
                label={gettext('E-mail address')}
                type="email"
                {...register('email', {
                    deps: ['phoneNumber'],
                })}
                error={errors.email?.message}
                helperText={gettext('CONTACT_FORM_EMAIL_FIELD_HELP_TEXT')}
            />
            <TextField
                label={gettext('Phone number')}
                type="tel"
                inputMode="tel"
                {...register('phoneNumber', {
                    deps: ['email'],
                })}
                error={errors.phoneNumber?.message}
                helperText={gettext('CONTACT_FORM_PHONE_FIELD_HELP_TEXT')}
            />
        </form>
    );
}
